import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { ILoyaltyStorage } from '@/shared/model/loyalty-storage.model';

const baseApiUrl = 'api/loyalty-storages';
const baseSearchApiUrl = 'api/_search/loyalty-storages?query=';

export default class LoyaltyStorageService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<ILoyaltyStorage> {
    return new Promise<ILoyaltyStorage>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: ILoyaltyStorage): Promise<ILoyaltyStorage> {
    return new Promise<ILoyaltyStorage>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: ILoyaltyStorage): Promise<ILoyaltyStorage> {
    return new Promise<ILoyaltyStorage>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
